import { useSubscriber } from 'app/socketConnection';
import { LockStatusChange } from 'entities/Box';

export const useOnLockStatusChanged = (): Nullable<LockStatusChange> => useSubscriber<LockStatusChange>('lockStatusChanged');
